import { useKestrel } from 'features/kestrelViewer'
import { KestrelScreenshotBridge } from 'features/kestrelViewer/KestrelScreenshotBridge'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { HelperText } from 'features/kestrelViewer/ui/HelperText'
import { MarkupPopupMenu } from 'features/kestrelViewer/ui/popupMenu/MarkupPopupMenu'
import { Settings } from 'features/kestrelViewer/ui/Settings'
import { DataValidationControl } from 'features/kestrelViewer/ui/tools/dataValidation/DataValidationControl'
import { InspectionGridSettings } from 'features/kestrelViewer/ui/tools/inspectionGrid/InspectionGridSettings'
import { KestrelViewerTools } from 'features/kestrelViewer/ui/tools/KestrelViewerTools'
import { PhotoReelModal } from 'features/kestrelViewer/ui/tools/photoreel/carousel/PhotoReelModal'
import { PlaneControls } from 'features/kestrelViewer/ui/tools/PlaneControls'
import { PrimitiveBuilderTools } from 'features/kestrelViewer/ui/tools/PrimitiveBuilderTools'
import { TemperatureDisplay } from 'features/kestrelViewer/ui/tools/TemperatureDisplay'
import { TextSegmentationTools } from 'features/kestrelViewer/ui/tools/TextSegmentationTools'
import { LayerHotbar } from 'features/kestrelViewer/ui/tools/viewControls/LayerHotbar'
import { ThermalGradientPanel } from 'features/kestrelViewer/ui/tools/viewControls/ThermalGradientLeftPanel'
import { PermissionsGate } from 'features/permissions'
import React from 'react'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { InfoModal } from './tools/InfoModal'

export const KestrelViewerUI: React.FC = () => {
  const {
    selectedMarkup,
    is2DPlaneModeActive,
    selectedMode,
    activeLayer,
    kestrelModel,
    selectedPhoto,
    setSelectedPhoto,
    photos,
    filteredPhotos,
    getPhotoRotation,
    setPhotoRotation,
    savePhotoRotations,
    textSegmentationPopoverVisible,
  } = useKestrelViewerContext()
  const { gatekeeper } = useKestrel()

  const displayPhotos = filteredPhotos || photos

  const isActiveRaw = activeLayer.type === 'raw'

  return (
    <>
      <KestrelViewerTools />
      <HelperText />
      <Settings />
      {kestrelModel?.data.photosEnabled && selectedPhoto && (
        <PhotoReelModal
          photo={selectedPhoto}
          photos={displayPhotos}
          onClose={() => {
            savePhotoRotations()
            setSelectedPhoto(null)
          }}
          onPhotoChange={setSelectedPhoto}
          rotation={getPhotoRotation(selectedPhoto.id)}
          onRotationChange={(r) => setPhotoRotation(selectedPhoto.id, r)}
        />
      )}
      {gatekeeper.feature.layerHotbar && <LayerHotbar />}
      {gatekeeper.feature.dataValidationControl && <DataValidationControl />}
      {gatekeeper.feature.thermalGradientPanel && isActiveRaw && (
        <ThermalGradientPanel />
      )}
      {gatekeeper.feature.temperatureDisplay && <TemperatureDisplay />}
      {gatekeeper.feature.inspectionGridSettings && <InspectionGridSettings />}
      {gatekeeper.feature.infoModal && <InfoModal />}
      {!!selectedMarkup && <MarkupPopupMenu />}
      {is2DPlaneModeActive && <PlaneControls />}
      {selectedMode === 'primitivebuilder' && <PrimitiveBuilderTools />}
      {textSegmentationPopoverVisible && (
        <PermissionsGate requires={[PERMISSION_GECKO_INTERNAL_MEMBER]}>
          <TextSegmentationTools />
        </PermissionsGate>
      )}
      <KestrelScreenshotBridge />
    </>
  )
}
